import { render, staticRenderFns } from "./TenantForm.vue?vue&type=template&id=770f1609&scoped=true&"
import script from "./TenantForm.vue?vue&type=script&lang=js&"
export * from "./TenantForm.vue?vue&type=script&lang=js&"
import style0 from "./TenantForm.vue?vue&type=style&index=0&id=770f1609&lang=scss&scoped=true&"
import style1 from "./TenantForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f1609",
  null
  
)

export default component.exports